module.exports = __webpack_public_path__ + "img/blood_pressure_primary.fc487573.svg";